// 空模块占位文件，用于 webpack 解析纯类型包（@cloudbase/types）的子路径引用
// 这些引用只有 TypeScript 类型，编译后会被擦除，运行时不需要任何内容
module.exports = {}
